export default "__VITE_ASSET__BnH$m8HD__";